export type Value = number | string | boolean;

export interface ControlItem {
    value: Value;
    label: string;
    label2?: string | null | undefined;
    icon?: string;
    unRoundedSendValue?: string;
    defaultDisplayText?:string;
}
